import React from 'react'
import { Grid } from '@material-ui/core'
import { components, useTranslation } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import CommonConfigKeys from 'src/constants/locale/key/CommonConfig'
import Namespace from 'src/constants/locale/Namespace'
import CommonConfigEditForm from './CommonConfigEditForm'

const { CngTabs } = components


function EditPage({ showNotification }) {
  const { id } = useParams()
  const { translate } = useTranslation([Namespace.BATCH_DATA_CONFIG])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let CommonConfig = translate(
      Namespace.BATCH_DATA_CONFIG,
      CommonConfigKeys.TITLE
    )

    return {
      CommonConfig
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <CommonConfigViewForm
              showNotification={showNotification}
              id={id}
              onFetchPreSuccess={(datum) => {
              }}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.CommonConfig,
              tabContent: (
                <CommonConfigEditForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default EditPage